import {
  Activity,
  Bike,
  Dumbbell,
  Flower2,
  Footprints,
  Volleyball,
  Waves,
  Zap,
  type LucideIcon,
} from 'lucide-react'
import type { ActivityType } from '@movmania/core'

/**
 * Un seul jeu d'icônes, même famille et même épaisseur de trait partout.
 * Les emojis sont proscrits : rendu dépendant de la police, incontrôlable en
 * couleur, et impossible à aligner proprement sur une ligne de base.
 */
export const ACTIVITY_ICONS: Record<ActivityType, LucideIcon> = {
  walk: Footprints,
  run: Zap,
  bike: Bike,
  swim: Waves,
  strength: Dumbbell,
  yoga: Flower2,
  sport: Volleyball,
  other: Activity,
}

export const ICON_STROKE = 2
